<template>
	<div class="content">
		<div class="menu-right">
			<div class="title">
				<span>怎么查看我的订单</span>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<p v-for="(item1,index1) in item.list" :key="index1">{{item1.text}}</p>
				<img :src="item.img.url" :alt="item.img.alt">
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			clauseList: [
				{
					title: '打开APP点击【个人】-点击【我的订单】可查询您的订单状态。',
					img: {
						url: require('../assets/images/QR_android.png'),
						alt: '陌陌回收二维码'
					},
					list: [
						{text: '如有其他问题'},
						{text: '手机扫一扫，下载陌陌回收app，人工客服为你解答'}
					]
				},
			]
		}
	}
}
</script>

<style scoped>
.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #3c78eb;
	padding-bottom: 4px;
}

.menu-right p{
	font-size: 16px;
	line-height: 30px;
	color: #3c78eb;
	margin-top: 20px;
	text-align: center;
}

.menu-right .inner img{
	display: block;
	margin: 20px auto;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #282828;
}
</style>
